import { FC, useEffect } from 'react';

import { useAuth } from '@/hooks/useAuth.tsx';
import LottieAnimation from '@/animations/LottieAnimation.tsx';
import loadingAnimationData from '@/components/common/svg/assets/loader_rounded.json';

const IndexPage: FC = () => {
  const { login, isFetching } = useAuth();

  const init = async () => {
    await login();
  };

  useEffect(() => {
    void init();
  }, []);

  return (
    <>
      {isFetching && (
        <div
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <LottieAnimation
            width={70}
            height={70}
            animationData={loadingAnimationData}
            shouldAnimate={true}
            loop={true}
          />
        </div>
      )}
    </>
  );
};

export default IndexPage;
